import get from 'lodash/get'

import * as commonSelectors from 'apps/templates/selectors/commonSelectors'

export const getFullCurrent = (state) => get(state, 'templates.current', {})

export const getError = (state) => getFullCurrent(state).error

export const isFetching = (state) => getFullCurrent(state).fetching

export const getCurrent = (state) => getFullCurrent(state).item

export const getPageId = (state) => get(getCurrent(state), 'current_version.page_id', null)

export const getBasePageName = (state) => getCurrent(state)?.current_version.base_page_name || ''

export const getShareType = (state) => commonSelectors.getShareType(getCurrent(state))

export const getShareLink = (state) => commonSelectors.getShareLink(getCurrent(state))

export const getIsGeneratingLink = (state) => commonSelectors.getIsGeneratingLink(getCurrent(state))

export const getApps = (state) => getCurrent(state)?.current_version?.map?.apps
